import { IInspectionPart } from "../store/types";

/** Progress of an incomplete inspection. */
export interface IInspectionProgress {
    completed: number;
    total: number;
    percentage: number;
}

/** Total number of inspection items across all parts (sections). */
export function countTemplateItems(inspectionParts: IInspectionPart[]): number {
    let totalItems = 0;
    for (const part of inspectionParts) {
        totalItems += part.inspectionItems?.length ?? 0;
    }
    return totalItems;
}

/**
 * Calculates inspection progress from completed and total item counts.
 * An empty template (total 0) reports 0 of 0, 0%, whatever `completed` is.
 */
export function calculateInspectionProgress(
    completed: number,
    total: number
): IInspectionProgress {
    if (total === 0) {
        return { completed: 0, total: 0, percentage: 0 };
    }

    const percentage = Math.round((completed / total) * 100);
    return { completed, total, percentage };
}